module.exports = __webpack_public_path__ + "img/logo.c3c344bd.png";